<script setup>
import { computed } from "vue";
import PricingPlans from "./components/PricingPlans.vue";

import {ChevronLeft} from "lucide-vue-next"

const pageTitle = computed(() => {
  return ''
})

const showBackButton = computed(() => {
  return false;
})
</script>

<template>

  <div class="flex flex-col w-full overflow-x-hidden">
        <!-- Navigation Bar -->
        <nav class="bg-white w-full z-50">
            <div
                class="mx-auto px-4 py-6 flex items-center"
                :class="{
                    'gap-2 lg:gap-4': showBackButton,
                }"
            >
                <div>
                    <a href="/">
                        <img src="/logo/logo.png" alt="Amana Logo" class="h-[40px] w-[38px]" />
                    </a>
                </div>
                <div class="flex flex-1 items-center justify-between">
                  <div class="flex flex-1 items-center justify-center">
                      <span class="font-medium text-sm lg:text-xl text-primary-font">
                        {{ pageTitle }}
                      </span>
                  </div>
                  <div
                      v-if="showBackButton"
                      class="flex items-center justify-end cursor-pointer font-medium text-sm text-sub600"
                      @click="goBack"
                  >
                    <ChevronLeft class="w-4 h-4 mr-2" />
                    <span>Go Back</span>
                  </div>
                </div>
            </div>
            <div class="w-full h-px bg-primary-border"></div>
        </nav>

        <div class="w-full flex justify-center items-center">
          <PricingPlans />
        </div>
  </div>

    <div>
        <notificationGroup>
      <div
        class="fixed inset-0 flex px-4 py-6 pointer-events-none p-6 items-start justify-end z-9999"
      >
        <div class="max-w-sm w-full">
          <notification v-slot="{ notifications }">
            <div
              class="flex max-w-sm w-full mx-auto bg-white shadow-md rounded-lg overflow-hidden mt-4"
              v-for="notification in notifications"
              :key="notification.id"
            >
              <div class="flex justify-center items-center w-12 " :class="{
                        'bg-green-500 font-semibold': notification.title === 'Success',
                        'bg-red-500 font-semibold': notification.title !== 'Success'
                    }">
                <svg
                  class="h-6 w-6 fill-current text-white"
                  viewBox="0 0 40 40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z"
                  ></path>
                </svg>
              </div>

              <div class="-mx-3 py-2 px-4">
                <div class="mx-3">
                    <span
                    :class="{
                        'text-green-500 font-semibold': notification.title === 'Success',
                        'text-red-500 font-semibold': notification.title !== 'Success'
                    }"
                    >
                    {{ notification.title }}
                    </span>
                    <p class="text-gray-600 text-sm">{{ notification.text }}</p>
                </div>
                </div>
            </div>
          </notification>
        </div>
      </div>
    </notificationGroup>
    </div>

</template>
